import { CreatableTaskLinkRelationship, TaskLink, TaskLinkRelationship } from '@/tracker/types';

/** Как в Яндекс Трекере: кем эта задача приходится второй */
export const LINK_LABELS: Record<TaskLinkRelationship, string> = {
  relates: 'Связана с',
  depends_on: 'Зависит от',
  blocks: 'Блокирует',
  duplicates: 'Дублирует',
  duplicated_by: 'Дублируется',
  clone_of: 'Клон задачи',
  cloned_by: 'Клонирована в',
};

/** Клоны создаёт только импорт */
export const CREATABLE_LINKS: CreatableTaskLinkRelationship[] = [
  'relates',
  'depends_on',
  'blocks',
  'duplicates',
  'duplicated_by',
];

/** Сервер отдаёт связи по типу — собираем подряд идущие в группы */
export const groupLinks = (links: TaskLink[]) =>
  links.reduce<{ relationship: TaskLinkRelationship; links: TaskLink[] }[]>((groups, link) => {
    const last = groups[groups.length - 1];

    if (last?.relationship === link.relationship) last.links.push(link);
    else groups.push({ relationship: link.relationship, links: [link] });

    return groups;
  }, []);
